import React, { useEffect } from "react";
import { Col, DatePicker, Flex, InputNumber, Row } from "antd";
import { useState } from "react";
import { useRef } from "react";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../../constants/routeConsts";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  dateObjToDispViewDate,
  sanitizeDataTypeClientSide,
} from "../../../../../../utils/utils";
import dayjs from "dayjs";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import {
  createGiftCardAction,
  getGiftCardByIdAction,
  updateGiftCardAction,
} from "../../../../../../redux/services/gift-card/giftCardServices";
import TextArea from "antd/es/input/TextArea";
import {
  createOrganizationSponsorshipAction,
  getOrganizationSponsorshipByIdAction,
  updateOrganizationSponsorshipAction,
} from "../../../../../../redux/services/organization-sponsorship/organizationSponsorshipServices";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";

const OrganizationSponsorshipForm = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const start = Form.useWatch("start", { form, preserve: true });
  /* form dependencies */

  /* id dependencies */
  const { selectedOrganizationSponsorshipId } = useSelector(
    (state) => state.organizationSponsorships
  );
  /* id dependencies */

  /* function definition for select list API calls */
  const selectListApiCalls = (details) => {};
  /* function definition for select list API calls */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedOrganizationSponsorshipId &&
      selectedOrganizationSponsorshipId !== "" &&
      selectedOrganizationSponsorshipId !== null &&
      selectedOrganizationSponsorshipId !== undefined
    ) {
      const dataToBeSent = {
        selectedOrganizationSponsorshipId,
      };
      dispatch(
        getOrganizationSponsorshipByIdAction(dataToBeSent, setLoading)
      ).then((apiRes) => {
        const response = apiRes;
        const locale = apiRes?.locales ? apiRes?.locales[0] : response;

        selectListApiCalls(response);

        form.setFieldsValue({
          name: response?.name,
          name_ar: locale?.name,
          price: response?.price,
          duration: response?.duration,
          description: response?.description,
          description_ar: locale?.description
        });
      });
    } else {
    /* initial dependencies - Edit */
      selectListApiCalls(null);
    }
  }, []);

  /* Form submit handler */
  const onSubmit = (values) => {
    const { price, ...rest } = values;
    const dataToBeSent = {
      ...rest,
      price: Number(price),
      duration_unit: "month",
      currency: "aed",
    };

    if (
      selectedOrganizationSponsorshipId &&
      selectedOrganizationSponsorshipId !== "" &&
      selectedOrganizationSponsorshipId !== null &&
      selectedOrganizationSponsorshipId !== undefined
    ) {
      dataToBeSent._id = selectedOrganizationSponsorshipId;
      dispatch(updateOrganizationSponsorshipAction(dataToBeSent, setLoading));
    } else {
      dispatch(createOrganizationSponsorshipAction(dataToBeSent, setLoading));
    }
    navigate(baseRouteMakerForSuperAdmin(routes.ORGANIZATION_SPONSORSHIP));
  };
  /* Form submit handler */

  return (
    <div className="organizationSponsorshipContainer">
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(
                baseRouteMakerForSuperAdmin(routes.ORGANIZATION_SPONSORSHIP)
              )
            }
          />
          <Title level={2}>
            {t("Modules.Ads.addOrganizationTopListingPlan")}
          </Title>
        </Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[24, 24]}>
            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel text={t("Modules.Ads.name")} required={true} />
                }
                name="name"
                rules={[
                  {
                    required: true,
                    message: t("Modules.Ads.pleaseEnterName"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.Ads.pleaseEnterName"),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input placeholder={t("Modules.Ads.enterName")} />
              </Form.Item>
            </Col>

            <Col span={8}>
            <Form.Item
                    label={
                      <RequiredLabel
                        text={`${t("Modules.Ads.name")} ${t("CommonUtils.inArabic")}`}
                        required={true}
                      />
                    }
                    name="name_ar"
                    rules={[
                      {
                        required: true,
                        message: `${t("Modules.Ads.pleaseEnterName")} ${t("CommonUtils.inArabic")}`,
                      },
                      {
                        whitespace: true,
                        message: `${t("Modules.Ads.pleaseEnterName")} ${t("CommonUtils.inArabic")}`,
                      },
                    ]}
                    normalize={(value) => sanitizeDataTypeClientSide(value)}
                  >
                    <Input
                      dir="rtl"
                      placeholder={`${t("Modules.Ads.enterName")} ${t("CommonUtils.inArabic")}`}
                    />
                  </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.DiscountCodes.DiscountCodesForm.amount")}
                    required={true}
                  />
                }
                name="price"
                rules={[
                  {
                    required: true,
                    message: t(
                      "Modules.DiscountCodes.DiscountCodesForm.pleaseEnterAmount"
                    ),
                  },
                  {
                    validator: (_, value) => {
                      if (value && value < 1)
                        return Promise.reject(
                          `${t(
                            "Modules.DiscountCodes.DiscountCodesForm.amount"
                          )} ${t("CommonUtils.shouldBeGreaterThan0")}`
                        );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder={t(
                    "Modules.DiscountCodes.DiscountCodesForm.pleaseEnterAmount"
                  )}
                  onKeyDown={(e) => allowCharactersOnlyForDecimalNumbers(e)}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="duration"
                label={
                  <RequiredLabel
                    text={t("Modules.Ads.period")}
                    required={true}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: t("Modules.Ads.pleaseSelectPeriod"),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={[
                    { value: 1, label: "01 month" },
                    { value: 4, label: "04 months" },
                    { value: 6, label: "06 months" },
                    { value: 12, label: "12 months" },
                  ]}
                  placeholder={t("Modules.Ads.selectPeriod")}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("Modules.Notify.description")}
                    required={true}
                  />
                }
                name="description"
                rules={[
                  {
                    required: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                  {
                    whitespace: true,
                    message: t("Modules.Notify.pleaseEnterDescription"),
                  },
                ]}
                // normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <TextArea
                  rows={4}
                  showCount
                  maxLength={
                    appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                  }
                  placeholder={t(
                    "CommonUtils.enterDescriptionUpto255Characters"
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={
                  <RequiredLabel
                    text={`${t(
                      "Modules.Services.ServicesForm.description"
                    )} ${t("CommonUtils.inArabic")}`}
                    required={true}
                  />
                }
                name="description_ar"
                // normalize={(value) => sanitizeDataTypeClientSide(value)}
                rules={[
                  {
                    required: true,
                    message: `${t(
                      "Modules.Services.ServicesForm.pleaseEnterDescription"
                    )} ${t("CommonUtils.inArabic")}`,
                  },
                  {
                    whitespace: true,
                    message: `${t(
                      "Modules.Services.ServicesForm.pleaseEnterDescription"
                    )} ${t("CommonUtils.inArabic")}`,
                  },
                ]}
              >
                <TextArea
                  dir="rtl"
                  rows={4}
                  showCount
                  maxLength={
                    appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA
                  }
                  placeholder={`${t(
                    "CommonUtils.enterDescriptionUpto255Characters"
                  )} ${t("CommonUtils.inArabic")}`}
                />
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Flex>
    </div>
  );
};

export default OrganizationSponsorshipForm;
